module.exports = "/docs/_next/static/images/logo-repman-4b9291a07dc56397b6c953637a2be43b.svg";